import React, { useState } from "react";
import styled from "styled-components";

import { navigationBarHeight } from "../../design";
import { IUser } from "../../interfaces";
import ProfileEditModal from "../organisms/AdminProfileEditModal";
import AdminRegisterModal from "../organisms/AdminRegisterModal";
import WithLoading from "../organisms/LoadingHOC";
import PageNavigation from "../organisms/PageNavigation";
import UserList from "../organisms/UserList";
import UserProfileModal from "../organisms/UserProfileModal";

import { LoadingContainer } from "../../containers/LoadingContainer";
import { UserListContainer } from "../../containers/UserListContainer";
import useNavigationBar from "../../customHook/NavigationBarHook";

interface IProps {}

const UserListPage: React.FC<IProps> = () => {
  const [selectedUser, selectUser] = useState<IUser | null>(null);

  const searchBox = useNavigationBar().searchBox;
  const adminRegisterModal = useNavigationBar().adminRegisterModal;
  const profileEditModal = useNavigationBar().profileEditModal;
  const loading = LoadingContainer.useContainer();
  const userList = UserListContainer.useContainer().userList;

  const UserListWithLoading = WithLoading(UserList);

  const displayUsers =
    searchBox.searchText !== "" ? userList.matchUsers : userList.users;

  return (
    <PageNavigation
      title={`友だち（${userList.users.length}人）`}
      active="users"
      searchBoxState={searchBox}
      adminRegisterModalState={adminRegisterModal}
      profileEditModalState={profileEditModal}
    >
      <AdminRegisterModal
        modalState={adminRegisterModal}
        style={adminRegisterModal.isOpen ? undefined : { display: "none" }}
      />
      <ProfileEditModal
        modalState={profileEditModal}
        style={profileEditModal.isOpen ? undefined : { display: "none" }}
      />
      <UserListAlign>
        <UserListWithLoading
          isLoading={loading.isloading}
          users={displayUsers}
          selectUser={(user: IUser) => selectUser(user)}
        />
        {!loading.isloading && displayUsers.length === 0 && (
          <NoHitStyle>検索結果はありません</NoHitStyle>
        )}
        <UserProfileModal user={selectedUser} close={() => selectUser(null)} />
      </UserListAlign>
    </PageNavigation>
  );
};

export default UserListPage;

const UserListAlign = styled.div`
  margin-top: ${navigationBarHeight};
`;

const NoHitStyle = styled.div`
  text-align: center;
  padding: 20px;
`;
